import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { UserService } from 'src/app/core/services/user.service';
import {
  getSecondsDiff,
  getUnitAndValueDate,
} from 'src/app/modules/dashboard/utils/time_formatter';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import {
  INotification,
  NotificacionService,
} from 'src/app/services/notificaciones.service';

@Component({
  selector: 'notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
})
export class NotificationItemComponent implements OnInit {
  @Input() notificacion: INotification;

  constructor(
    private readonly notificationService: NotificacionService,
    private router: Router,
    private readonly userService: UserService,
    private readonly caseService: CasesService
  ) {
    this.notificationService.markAllRead.subscribe(() => {
      this.notificacion.read = true;
    });
  }

  get photo() {
    const { user, userAction } = this.notificacion;
    const photo = userAction ? userAction.photo : user.photo;
    return photo || 'assets/images/user.png';
  }
  ngOnInit() {}

  get toolTipText() {
    return this.isUnread ? 'Marcar como leída' : 'Marcar como no leída';
  }

  get isUnread() {
    return !this.notificacion.read;
  }

  get description() {
    const { description, userAction } = this.notificacion;
    return userAction ? `${userAction.fullname} ${description}` : description;
  }

  changeMark($event) {
    $event?.stopPropagation();

    this.notificationService
      .changeStatus(this.isUnread, this.notificacion._id)
      .subscribe({
        next: (notification) => {
          this.notificacion = notification;
          this.notificationService.updateUnreads.next();
        },
      });
  }

  async open() {
    // if(this.userService.currentUser.role){
    //  let x = this.userService.currentUser.role.units
    // let find = x.find((x)=>x._id == this.notificacion.case?.caseType.unit._id)

    // }
    this.notificationService.makeAsRead(this.notificacion._id);
    if (
      this.notificacion.redirectTo.slice(0, 6) == '/case/' &&
      this.userService.isRas
    ) {
      this.caseService
        .getCase(this.notificacion.redirectTo.slice(0, 6))
        .subscribe((iCase) => {
          if (
            iCase.status != 'archived' ||
            this.userService.currentUser.role.seeArchivedCases
          ) {
            this.router.navigate([
              `/caseRas/${this.notificacion.redirectTo.slice(
                6,
                this.notificacion.redirectTo.length
              )}`,
            ]);
          }
        });
    } else if (
      this.notificacion.case?.caseType.unit.code == 'ALT' ||
      this.notificacion.case?.caseType.unit.code == 'ANA'
    ) {
      this.caseService
        .getCase(this.notificacion.redirectTo.slice(6))
        .subscribe((iCase) => {
          if (
            iCase.status != 'archived' ||
            this.userService.currentUser.role.seeArchivedCases
          ) {
            // this.router.navigate([this.notificacion.redirectTo]);

            this.router.navigate([
              `/casesnew/${this.notificacion.redirectTo.slice(
                6,
                this.notificacion.redirectTo.length
              )}`,
            ]);
          }
        });
    } else {
      this.router.navigate([this.notificacion.redirectTo]);
    }
  }

  timeAgo(date, locale) {
    const intl: any = Intl;
    const rtf = new intl.RelativeTimeFormat(locale);
    const secondsElapsed = getSecondsDiff(Date.parse(date));
    const { value, unit } = getUnitAndValueDate(secondsElapsed);
    return rtf.format(value, unit);
  }
}
